export default "__VITE_ASSET__7b904c17__"